import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import SettingFields from './SettingFields'

export const SettingCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <SettingFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default SettingCreate
